import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  isMenuOpen: boolean = false;
  isMenuCollapsed = true;
  isSubMenuActive = false; 
  isProductsActive = false;
  showSubmenu = false;
  isSubMenuOpen: boolean = false;
  isSpanishLang: boolean;
  isEnglishLang: boolean;
  isDeutchLang: boolean;
  isItLang: boolean;
  isFrLang: boolean;
  isPoLang: boolean;
  isRoLang: boolean;
  selectedLanguage: string;


  languages = [
    { code: 'es', label: 'ESPAÑOL (ESPAÑA)' },
    { code: 'en', label: 'ENGLISH (UK/USA)' },
    { code: 'de', label: 'DEUTSCH (DEUTSCHLAND)' },
    { code: 'fr', label: 'FRANÇAIS (FRANCE)' },
    { code: 'it', label: 'ITALIANO (ITALIA)' },
    { code: 'po', label: 'POLISH (POLAND)' },
    { code: 'ro', label: 'ROMÂNĂ (ROMÂNIA)' },
     { code: 'ch', label: 'CZECH (ČESKÁ REPUBLIKA)'}
  ];


  switchLanguage(code: string) {
    // Blindaje: ignora cualquier valor que no sea un código de idioma válido
    // (p. ej. si por error llegara un evento de click). Evita URLs corruptas.
    if (typeof code !== 'string' || this.languages.findIndex(l => l.code === code) === -1) {
      return;
    }
    // Cambia el idioma navegando a la misma página bajo el nuevo prefijo de idioma
    // (/de/products -> /es/products). langGuard se encarga de activar el idioma.
    this.selectedLanguage = code;
    this.preferredLang = code;
    this.translate.use(code);
    const path = this.router.url.split('?')[0];
    const rest = path.split('/').filter(s => s.length).slice(1); // quita el idioma actual
    this.router.navigate(['/' + code, ...rest], { queryParamsHandling: 'preserve' });
  }
  getSelectedLanguageLabel(): string {
    const selectedLang = this.languages.find(lang => lang.code === this.selectedLanguage);
    return selectedLang ? selectedLang.label : '';
  }
  
  
  get currentLanguage() {
    return this.translate.currentLang;
  }

  // Etiqueta del idioma activo (siempre sincronizada con ngx-translate).
  get currentLanguageLabel(): string {
    const code = this.translate.currentLang || this.translate.getDefaultLang() || 'en';
    return this.getLanguageLabel(code);
  }
  currentSection: string = ''; 


  changeSection(section: string) {
    this.currentSection = section;
    console.log(this.currentSection)
  }

  constructor(private viewportScroller: ViewportScroller, private route: ActivatedRoute, private router: Router,private translate: TranslateService) {
    this.isSpanishLang = this.translate.currentLang === 'es';
    this.isEnglishLang = this.translate.currentLang === 'en';
    this.isDeutchLang = this.translate.currentLang === 'de';
    this.isItLang = this.translate.currentLang === 'it';
    this.isFrLang = this.translate.currentLang === 'fr';
    this.isPoLang = this.translate.currentLang === 'po';
    this.isRoLang = this.translate.currentLang === 'ro';

  }



preferredLang: string;

ngOnInit() {
  this.route.queryParamMap.subscribe(queryParams => {
    this.currentSection = queryParams.get('section') || ''; 
    this.highlightActiveSection(this.currentSection);
  });

  // El idioma activo lo fija langGuard a partir del segmento de la URL.
  // Aquí solo reflejamos ese estado en la UI del selector.
  this.selectedLanguage = this.translate.currentLang || this.translate.getDefaultLang() || 'en';
  this.preferredLang = this.selectedLanguage;
  this.translate.onLangChange.subscribe(e => {
    this.selectedLanguage = e.lang;
    this.preferredLang = e.lang;
  });
}

onSubMenuClick(langCode: string) {
  this.switchLanguage(langCode);
  this.preferredLang = langCode;  // Actualizar preferredLang con el código de idioma seleccionado
  console.log('Preferred language:', this.preferredLang);
  this.closeMenu();
}

onSubMenuOptionClick(langCode: string) {
  this.selectedLanguage = langCode;
  this.switchLanguage(langCode);
  this.closeMenu();
}
getLanguageLabel(langCode: string): string {
  const selectedLang = this.languages.find(lang => lang.code === langCode);
  return selectedLang ? selectedLang.label : '';
}

getPreferredLanguageLabel(): string {
  const preferredLang = this.languages.find(lang => lang.code === this.preferredLang);
  return preferredLang ? preferredLang.label : '';
}


  closeMenu() {
    this.isMenuOpen = false;
    this.classApplied = false; 
    this.isSubMenuActive = false;

  }
  
  classApplied = false;
  toggleClass() {
      this.classApplied = !this.classApplied;
  }
  

  onClick(elementId: string): void {
    this.viewportScroller.scrollToAnchor(elementId);
    this.highlightActiveSection(elementId);
    this.isMenuOpen = false; 
  }

  highlightActiveSection(sectionId: string): void {
    const navLinks = document.querySelectorAll('.navbar-nav .link-btn');
    navLinks.forEach(link => {
      link.classList.remove('active');
      const routerLink = link.getAttribute('href');
      if (routerLink && routerLink === `/${sectionId}`) {
        link.classList.add('active');
      }
    });
  }
  toggleSubMenu() {
    this.isSubMenuOpen = !this.isSubMenuOpen;
  }


  closeSubMenu() {
    this.isSubMenuActive = false;
  }


switchToSpanish() {
  this.switchLanguage('es');
}
switchToEnglish() {
  this.switchLanguage('en');
}
switchToDeuch() {
  this.switchLanguage('de');
}
switchToIt() {
  this.switchLanguage('it');
}
switchToFr() {
  this.switchLanguage('fr');
}
switchToPo() {
  this.switchLanguage('po');
}
switchToRo() {
  this.switchLanguage('ro');
}
switchToCh() {
  this.switchLanguage('ch');
}

  closeSubMenuOnOutsideClick() {
    this.isSubMenuOpen = false;
  }
  isSubMenuOpenForHamburger = false; 


  toggleSubMenuForHamburger() {
    this.isSubMenuOpenForHamburger = !this.isSubMenuOpenForHamburger;
  }

}